import { dashboardApi } from '../store/services/dashboard'
import { authApi } from "../store/services/auth"
import { disciplineApi } from "../store/services/disciplines";
import { goalsApi } from "../store/services/goals";
import { designationsApi } from "../store/services/designations";
import { therapistApi } from "../store/services/therapistProfiles";
import { utilityApi } from "../store/services/utility";
import { schoolsApi } from "../store/services/schools";
import { schoolDivisonsApi } from "../store/services/schoolsDivisons";
import { schoolClientsApi } from "../store/services/clients/school.client";
import { clientCaseLoadsApi } from "../store/services/clientCaseLoads";
import { homeEducationApi } from "../store/services/clients/homeEducation.client";
import { clientChatterApi } from "../store/services/clients/chatter.client";
import { privateClientApi } from "../store/services/clients/private.client";
import { manageStatusApi } from "../store/services/clients/manageStatus";
import { fundingSourceApi } from '../store/services/fundingSource';
import { chatterProgramApi } from '../store/services/chatter/program';
import { chatterLessonApi } from '../store/services/chatter/lesson';
import { chatterPeerApi } from '../store/services/chatter/peer';
import { mdtAssessmentApi } from '../store/services/MDT/assessment';
import { mdtStatusApi } from '../store/services/MDT/status';
import { mdtTermsApi } from '../store/services/MDT/terms';
import { serviceStatusApi } from '../store/services/serviceStatus';
import { parentsAPi } from '../store/services/parents';
import { teachersApi } from '../store/services/teachers';
import { supportStaffApi } from '../store/services/supportStaff';
import { archiveApi } from '../store/services/archive';
import { cmsApi } from '../store/services/cms';
import { notificationApi } from '../store/services/notification';
import { noteApi } from '../store/services/note';
import { guardianApi } from '../store/services/guardian';
import { resourceApi } from '../store/services/resource';
import { chatApi } from '../store/services/chat';
import { rolesApi } from '../store/services/users/role';
import { profileApi } from '../store/services/profile';
import { accountApi } from '../store/services/users/account';
import { forgotPasswordApi } from '../store/services/forgotPassword';
import { attendanceApi } from '../store/services/attendance';
import { exportApi } from '../store/services/export';
import { consentApi } from '../store/services/consent';
import { miscApi } from "store/services/misc.service";
import { baseApi } from "utils/axios/baseApi";
import { receiptApi } from 'store/services/receipts';
import { dischargeApi } from 'store/services/discharge';
import { apprenticeApi } from 'store/services/apprentice';
import { schoolBannersApi } from 'store/services/schoolBanners';
import { coordinatorsApi } from 'store/services/coordinators';
import { notificationsApi } from 'store/services/notifications';
import { policiesApi } from 'store/services/policies';


export default [
  apprenticeApi,
  dashboardApi,
  authApi,
  schoolBannersApi,
  disciplineApi,
  goalsApi,
  designationsApi,
  therapistApi,
  utilityApi,
  schoolsApi,
  schoolDivisonsApi,
  schoolClientsApi,
  clientCaseLoadsApi,
  homeEducationApi,
  clientChatterApi,
  privateClientApi,
  manageStatusApi,
  fundingSourceApi,
  chatterProgramApi,
  chatterLessonApi,
  chatterPeerApi,
  mdtAssessmentApi,
  mdtStatusApi,
  mdtTermsApi,
  serviceStatusApi,
  parentsAPi,
  teachersApi,
  supportStaffApi,
  archiveApi,
  cmsApi,
  notificationApi,
  noteApi,
  guardianApi,
  resourceApi,
  chatApi,
  rolesApi,
  profileApi,
  accountApi,
  forgotPasswordApi,
  attendanceApi,
  exportApi,
  consentApi,
  miscApi,
  receiptApi,
  dischargeApi,
  coordinatorsApi,
  baseApi,
  notificationsApi,
  policiesApi
]